module.exports = __webpack_public_path__ + "img/AC171C_FA8593_E84854_D3464E-256px.87562c2e.png";